// NavLinks - Navigasyon linkleri (Projeler, Uzmanlar, Kategoriler)
// Active link highlight + hover effect
import { Briefcase, GraduationCap, Grid3x3 } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

interface NavLinksProps {
  mobile?: boolean
}

export default function NavLinks({ mobile = false }: NavLinksProps) {
  const location = useLocation()

  const links = [
    { path: '/projects', label: 'Projeler', icon: Briefcase },
    { path: '/experts', label: 'Uzmanlar', icon: GraduationCap },
    { path: '/discover', label: 'Kesfet', icon: Grid3x3 },
  ]

  const containerStyle = mobile
    ? {
        display: 'flex',
        flexDirection: 'column' as const,
        gap: 4,
      }
    : {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }

  return (
    <div style={containerStyle}>
      {links.map((link) => {
        const isActive = location.pathname === link.path
        const Icon = link.icon

        return (
          <Link
            key={link.path}
            to={link.path}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: mobile ? '10px 12px' : '8px 12px',
              borderRadius: 6,
              background: isActive ? 'var(--active-bg)' : 'transparent',
              color: isActive ? 'var(--accent-blue)' : 'var(--text-secondary)',
              textDecoration: 'none',
              fontSize: 13,
              fontWeight: isActive ? 600 : 500,
              transition: 'all .2s',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'var(--hover-bg)'
                e.currentTarget.style.color = 'var(--text-primary)'
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.background = 'transparent'
                e.currentTarget.style.color = 'var(--text-secondary)'
              }
            }}
          >
            <Icon size={16} />
            {link.label}
          </Link>
        )
      })}
    </div>
  )
}
